import { Button, Text } from '@noorden-insurtech/alba-design-system';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import type { CapitalGlobalProposalStepProps } from '../capital-global-proposal-step.types';

type Props = CapitalGlobalProposalStepProps & {
  stepTitle: string;
  stepDescription?: string;
};

export function StepCapitalGlobalPlaceholder({
  stepTitle,
  stepDescription,
  onNext,
  onBack,
  canGoNext,
  canGoBack,
  isViewMode,
}: Props) {
  return (
    <div className='flex flex-col gap-8'>
      <div className='space-y-2'>
        <Text className='text-lg font-bold text-alba-black-500'>
          {stepTitle}
        </Text>
        {stepDescription ? (
          <Text className='text-sm text-alba-gray-600'>{stepDescription}</Text>
        ) : null}
        <Text className='text-sm text-alba-gray-600'>
          Esta etapa será implementada em uma próxima entrega.
        </Text>
      </div>

      <div className='flex flex-row justify-between items-center gap-6 self-stretch'>
        <Button
          type='button'
          variant='ghost'
          size='lg'
          className='flex items-center gap-2'
          onClick={onBack}
          disabled={isViewMode || !canGoBack}
        >
          <ArrowLeft className='h-5 w-5' strokeWidth={1.6} />
          Voltar
        </Button>
        <Button
          type='button'
          variant='primary'
          size='md'
          className='flex items-center gap-2 px-8 py-2 rounded-xl'
          onClick={onNext}
          disabled={isViewMode || !canGoNext}
        >
          Próximo
          <ArrowRight className='h-6 w-6' strokeWidth={2} />
        </Button>
      </div>
    </div>
  );
}
